import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
import { Icon } from '@iconify/react';

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                {skills.imageSrc ? (
                  <img
                    src={typeof skills.imageSrc === "object" ? skills.imageSrc.default : skills.imageSrc}
                    alt={skills.skillName}
                    style={{width: "1em", height: "1em", verticalAlign: "middle"}}
                  />
                ) : (
                  <Icon icon={skills.classname} />
                )}
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
